import { createReducer } from 'typesafe-actions';
import { PageType, urlStateToWebUrl } from '@westwing/looks-url-service';
import { fetchLooksHeaderActions, LooksHeaderActionsType } from './actions';
import { HeaderLookItem, HeaderLooksRawData, HeaderLooksState } from './types';
import { defaultErrorHandler, defaultRequestHandler } from 'Client/redux/dataFetching/generators';

const mapHeaderLooksData = (data: HeaderLooksRawData[]): HeaderLookItem[] => {
    return data.map(slider => ({
        url: urlStateToWebUrl({
            pageType: PageType.LDP,
            look: slider.urlKey,
        }),
        imgUrl: slider.image.path,
        title: slider.title,
        caption: slider.caption,
        color: slider.color,
        isLandscape: slider.isLandscape,
        urlKey: slider.urlKey,
        trackingName: slider.trackingName,
        moodImgUrl: slider.moodImage.path,
    }));
};

export const defaultLooksState: HeaderLooksState = {
    isFetching: false,
    didInvalidate: false,
    identifier: '',
    looks: [],
};

export const looksHeaderReducer = createReducer<HeaderLooksState, LooksHeaderActionsType>(defaultLooksState)
    .handleAction(fetchLooksHeaderActions.success, (state, action) => {
        return {
            ...state,
            identifier: action.payload.identifier,
            looks: mapHeaderLooksData(action.payload.data.data),
            isFetching: false,
        };
    })
    .handleAction(fetchLooksHeaderActions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchLooksHeaderActions.request, (state, action) => defaultRequestHandler(state, action));
